<app-common-header-layout
  class="header"
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject$ | async"
>
  <ng-container *ngIf="didSucceed">
    <i2g-icon class="checkmark-icon success" [icon]="checkmarkIcon"> </i2g-icon>

    <div class="title">{{ 'VERIFY_EMAIL.SUCCESS_TITLE' | translate }}</div>

    <div class="description">
      {{ 'VERIFY_EMAIL.SUCCESS_DESCRIPTION' | translate }}
    </div>

    <button
      i2gButton
      buttonStyle="emphasis"
      i2gTrackable
      [trackingObject]="trackingObject$ | async"
      [trackingAction]="ctaTrackingAction"
      (click)="onCtaClicked()"
    >
      {{ 'VERIFY_EMAIL.BACK_TO_I2G' | translate }}
    </button>
  </ng-container>
  <ng-container *ngIf="!didSucceed">
    <i2g-icon class="checkmark-icon error" [icon]="errorIcon"> </i2g-icon>

    <div class="title">{{ 'VERIFY_EMAIL.FAILURE_TITLE' | translate }}</div>

    <div class="description">
      {{ 'VERIFY_EMAIL.FAILURE_DESCRIPTION' | translate }}
    </div>

    <button
      i2gButton
      buttonStyle="default"
      i2gTrackable
      [trackingObject]="trackingObject$"
      [trackingAction]="ctaTrackingAction"
      (click)="onCtaClicked()"
    >
      {{ 'ACTION.LOG_IN' | translate }}
    </button>
  </ng-container>
</app-common-header-layout>
